module.exports = __webpack_public_path__ + "static/media/power-hp2.9963595c.png";